"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FooterNav = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_1 = __importDefault(require("@emotion/styled"));
const Div_1 = require("./Div");
const Icon_1 = require("./Icon");
const Link_1 = require("./Link");
const constants_1 = require("../constants");
const Nav = styled_1.default.nav({
    backgroundColor: constants_1.Color.WHITE,
    borderTop: constants_1.theme.border.style.thin,
    position: 'relative',
});
const Ol = styled_1.default.ol `
  display: grid;
  grid-auto-flow: column;
  grid-auto-columns: 1fr;
  margin: 0;
`;
const StyledLink = (0, styled_1.default)(Link_1.Link, {
    shouldForwardProp: (prop) => !['active'].includes(prop),
})((props) => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: constants_1.theme.spacing[1],
    color: props.active ? constants_1.Color.BLUE : constants_1.Color.DARK_GREY,
    paddingTop: constants_1.theme.spacing[2],
    paddingRight: constants_1.theme.spacing[2],
    paddingBottom: constants_1.theme.spacing[2],
    paddingLeft: constants_1.theme.spacing[2],
    cursor: 'pointer',
    textDecoration: 'none',
    fontSize: constants_1.theme.font.size[6.5],
    '&:hover': {
        color: constants_1.Color.BLUE,
    },
}));
const Badge = styled_1.default.span({
    backgroundColor: constants_1.Color.RED,
    color: constants_1.Color.WHITE,
    borderRadius: 999,
    minWidth: '1.2em',
    minHeight: '1.2em',
    lineHeight: '1.2em',
    textAlign: 'center',
    paddingLeft: 4,
    paddingRight: 4,
    position: 'absolute',
    top: -4,
    left: '60%',
});
const Active = styled_1.default.div(({ itemCount, selectedIndex }) => ({
    position: 'absolute',
    bottom: 0,
    width: `${100 / itemCount}%`,
    height: 3,
    left: 0,
    background: constants_1.Color.BLUE,
    transform: `translateX(${100 * selectedIndex}%)`,
    transition: `transform ${constants_1.theme.animation.duration}s ease-in-out`,
    pointerEvents: 'none',
}));
const FooterNav = ({ className, items }) => {
    const selectedIndex = items.findIndex((item) => item.active);
    return ((0, jsx_runtime_1.jsxs)(Nav, { className: className, children: [(0, jsx_runtime_1.jsx)(Ol, { children: items.map(({ label, path, icon, badge, active }) => ((0, jsx_runtime_1.jsxs)(StyledLink, { to: path, active: active, children: [(0, jsx_runtime_1.jsxs)(Div_1.Div, { styles: { position: 'relative' }, children: [(0, jsx_runtime_1.jsx)(Icon_1.Icon, { name: icon, size: "md-plus", design: active ? 'solid' : 'outline' }), !!badge && (0, jsx_runtime_1.jsx)(Badge, { role: "status", children: badge })] }), label] }, path))) }), selectedIndex === -1 ? null : ((0, jsx_runtime_1.jsx)(Active, { itemCount: items.length, selectedIndex: selectedIndex }))] }));
};
exports.FooterNav = FooterNav;
